/**
 * SK Collection Machine Search
 *
 * Autosuggest dropdown embedded in the collection hero banner.
 * Searches machine models; clicking a result navigates to that machine's collection.
 * Supports infinite scroll: an IntersectionObserver watches a sentinel element at the
 * bottom of the dropdown and fetches the next page when it becomes visible.
 *
 * Requires: window.SK.machineSearchUrl
 * Backend endpoint: GET /machines/suggest?query=<term>&offset=<n>&limit=<n>
 * Response: { machines: [{ model, collectionTitle, collectionUrl }], products: [{ title, handle, url, image }], hasMore: bool }
 */
(function () {
    'use strict';

    var PAGE_SIZE = 15;

  function isApiReady() {
    return !!(window.SK && window.SK.machineSearchUrl);
  }

    function buildSuggestUrl(query, collection, offset) {
    try {
      var u = new URL(window.SK.machineSearchUrl, window.location.origin);
      u.pathname = u.pathname.replace(/\/+$/, '').replace(/[^/]+$/, 'machines/suggest');
      u.search = '';
      u.searchParams.set('query', query);
      u.searchParams.set('limit', String(PAGE_SIZE));
      if (offset > 0) u.searchParams.set('offset', String(offset));
            if (collection) u.searchParams.set('collection', collection);
            var locale = window.SK && window.SK.locale;
            if (locale) u.searchParams.set('locale', locale);
            return u.toString();
        } catch (e) {
            return null;
        }
    }

    var _div = document.createElement('div');

    function escapeHtml(str) {
        _div.textContent = String(str || '');
        return _div.innerHTML;
    }

    function isSafeUrl(url) {
    if (!url) return false;
    var s = String(url).trim();
    return /^https?:\/\//.test(s) || /^\/(?!\/)/.test(s);
  }

    // -------------------------------------------------------------------------
    // Module-level delegated click handler
    // -------------------------------------------------------------------------

    var _containers = [];

    document.addEventListener('click', function (e) {
        _containers.forEach(function (entry) {
            if (entry.container.isConnected && !entry.container.contains(e.target)) {
                entry.close();
            }
        });
    });

    // -------------------------------------------------------------------------
    // Dropdown HTML builders
    // -------------------------------------------------------------------------

    var _idSeq = 0;

    function buildProductsHtml(products) {
    if (!products || !products.length) return '';
    return '<ul class="sk-cms__list sk-cms__list--products" role="listbox">' +
      products.map(function (p) {
        var href = p.url || (p.handle ? '/products/' + p.handle : '#');
        var safeHref = isSafeUrl(href) ? escapeHtml(href) : '#';
        var img = p.image || p.featuredImage || null;
        var id = 'sk-cms-item-' + (++_idSeq);
        return '<li class="sk-cms__item sk-cms__item--product" role="option">' +
          '<a id="' + id + '" href="' + safeHref + '" class="sk-cms__link">' +
            (img
              ? '<img class="sk-cms__product-img" src="' + escapeHtml(img.url) + '" alt="' + escapeHtml(img.altText || '') + '" width="40" height="40" loading="lazy">'
              : '') +
            '<span class="sk-cms__model">' + escapeHtml(p.title) + '</span>' +
          '</a>' +
        '</li>';
      }).join('') +
    '</ul>';
  }

  function buildMachineItems(machines) {
    return machines.map(function (m) {
      var safeHref = isSafeUrl(m.collectionUrl) ? escapeHtml(m.collectionUrl) : '#';
      var id = 'sk-cms-item-' + (++_idSeq);
      return '<li class="sk-cms__item" role="option">' +
        '<a id="' + id + '" href="' + safeHref + '" class="sk-cms__link">' +
          '<span class="sk-cms__model">' + escapeHtml(m.model) + '</span>' +
          (m.collectionTitle
            ? '<span class="sk-cms__collection">' + escapeHtml(m.collectionTitle) + '</span>'
            : '') +
        '</a>' +
      '</li>';
    }).join('');
  }

  // -------------------------------------------------------------------------
  // Per-container search setup
    // -------------------------------------------------------------------------

    function setupSearch(container) {
        var input = container.querySelector('.collection-machine-search__input');
        var dropdown = container.querySelector('.collection-machine-search__dropdown');
        if (!input || !dropdown) return;

        var collection = container.dataset.collection || null;
        var i18nNoResults = container.dataset.i18nNoResults || 'No results available';
        var i18nNoResultsFor = container.dataset.i18nNoResultsFor || 'No results found for \u201c__QUERY__\u201d';
        var debounceTimer = null;
        var abortController = null;

        // Infinite-scroll state
    var currentQuery = '';
    var currentOffset = 0;
    var hasMore = false;
    var isLoading = false;
    var observer = null;
    var sentinel = null;

    // ── Sentinel / IntersectionObserver ──────────────────────────────────────

    function createObserver() {
      if (observer) return;
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && hasMore && !isLoading) {
          loadMore();
        }
      }, { root: dropdown, threshold: 0.1 });
    }

    function attachSentinel() {
      if (sentinel) return;
      createObserver();
      sentinel = document.createElement('div');
      sentinel.className = 'sk-cms__sentinel';
      dropdown.appendChild(sentinel);
      observer.observe(sentinel);
    }

    function detachSentinel() {
      if (sentinel) {
        if (observer) observer.unobserve(sentinel);
        if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
        sentinel = null;
      }
    }

    // ── Dropdown open / close ─────────────────────────────────────────────────

    function openDropdown() {
      dropdown.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
    }

        function closeDropdown() {
            dropdown.setAttribute('hidden', '');
            dropdown.innerHTML = '';
            input.setAttribute('aria-expanded', 'false');
            input.removeAttribute('aria-activedescendant');
            if (abortController) {
                abortController.abort();
                abortController = null;
      detachSentinel();
      hasMore = false;
      currentOffset = 0;
      isLoading = false;
    }}

        // ── Fetch helpers ─────────────────────────────────────────────────────────

    function doFetch(url, signal) {
      return fetch(url, { signal: signal })
        .then(function (r) {
          if (!r.ok) throw new Error('API error ' + r.status);
          return r.json();
        });
    }

    // Full refresh — new query or focus
    function fetchAndRender(q) {
      currentQuery = q;
      currentOffset = 0;
      hasMore = false;
      isLoading = true;
      detachSentinel();

      if (abortController) abortController.abort();
      abortController = new AbortController();

            var url = buildSuggestUrl(q, collection, 0);
            if (!url) { isLoading = false; return; }

            doFetch(url, abortController.signal)
                .then(function (data) {
          var machines = data.machines || [];
          var products = data.products || [];

          if (!machines.length && !products.length) {
            var emptyText = q
              ? i18nNoResultsFor.replace('__QUERY__', q)
              : i18nNoResults;
            var emptyEl = document.createElement('p');
            emptyEl.className = 'sk-cms__empty';
            emptyEl.textContent = emptyText;
            dropdown.innerHTML = '';
            dropdown.appendChild(emptyEl);
          } else {
            var html = buildProductsHtml(products);
            if (machines.length) {
              html += '<ul class="sk-cms__list sk-cms__list--machines" role="listbox">' +
                buildMachineItems(machines) +
              '</ul>';
            }
            dropdown.innerHTML = html;
          }

          openDropdown();
          currentOffset = machines.length;
          hasMore = !!data.hasMore;
          isLoading = false;

          if (hasMore) attachSentinel();
        })
        .catch(function (err) {
          isLoading = false;
                    if (err && err.name === 'AbortError') return;
                    closeDropdown();
                });
        }

        // Append next page of machines
    function loadMore() {
      if (isLoading || !hasMore) return;
      isLoading = true;

      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url = buildSuggestUrl(currentQuery, collection, currentOffset);
      if (!url) { isLoading = false; return; }

      // Show loading spinner in sentinel while waiting
      if (sentinel) sentinel.classList.add('sk-cms__sentinel--loading');

      doFetch(url, abortController.signal)
        .then(function (data) {
          var machines = data.machines || [];

          detachSentinel();

          if (machines.length) {
            var list = dropdown.querySelector('.sk-cms__list--machines');
            if (!list) {
              list = document.createElement('ul');
              list.className = 'sk-cms__list sk-cms__list--machines';
              list.setAttribute('role', 'listbox');
              dropdown.appendChild(list);
            }
            list.insertAdjacentHTML('beforeend', buildMachineItems(machines));
          }

          currentOffset += machines.length;
          hasMore = !!data.hasMore;
          isLoading = false;

          if (hasMore) attachSentinel();
        })
        .catch(function (err) {
          isLoading = false;
          if (sentinel) sentinel.classList.remove('sk-cms__sentinel--loading');
          // AbortError = new query started; silently discard this page
        });
    }

    // ── Event listeners ───────────────────────────────────────────────────────

        _containers.push({container: container, close: closeDropdown});

        input.addEventListener('focus', function () {
            if (!dropdown.hasAttribute('hidden')) return;
            fetchAndRender(input.value.trim());
        });

        input.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            var q = input.value.trim();
            debounceTimer = setTimeout(function () {
                fetchAndRender(q);
            }, 300);
        });

        function onKeydown(e) {
            if (e.key === 'Escape') {
                closeDropdown();
                return;
            }

            if (e.key === 'Enter') {
                e.preventDefault();
                var focused = dropdown.querySelector('.sk-cms__link:focus');
                if (focused) focused.click();
                return;
            }

            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var items = dropdown.querySelectorAll('.sk-cms__link');
        if (!items.length) return;
        var currentFocused = dropdown.querySelector('.sk-cms__link:focus');
        var idx = Array.prototype.indexOf.call(items, currentFocused);
        var next = e.key === 'ArrowDown'
          ? (items[idx + 1] || items[0])
          : (items[idx - 1] || items[items.length - 1]);
        next.focus();
        input.setAttribute('aria-activedescendant', next.id);
      }
    }

        input.addEventListener('keydown', onKeydown);
        dropdown.addEventListener('keydown', onKeydown);
    }

    function init() {
        if (!isApiReady()) return;
        document.querySelectorAll('[data-sk-collection-machine-search]').forEach(setupSearch);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
